import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLeaderboard: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-1-stroke-1.5-IconLeaderboard"><Path d="M10 6C9.17157 6 8.5 6.67157 8.5 7.5V18H15.5V7.5C15.5 6.67157 14.8284 6 14 6H10Z" fill="currentColor"/><Path d="M2 8.5C1.17157 8.5 0.5 9.17157 0.5 10V16.5C0.5 17.3284 1.17157 18 2 18H7V9.5C7 8.94772 6.55228 8.5 6 8.5H2Z" fill="currentColor"/><Path d="M18 10C17.4477 10 17 10.4477 17 11V18H22C22.8284 18 23.5 17.3284 23.5 16.5V11.5C23.5 10.6716 22.8284 10 22 10H18Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLeaderboard;
